<template>
	<div class="clearfix">
		<ul class="pagination pull-right">
			<li v-if="shouldRenderFirstLink">
				<router-link :to="getFirstLink()" title="Halaman pertama" :disabled="disabled">
					<i class="fa fa-step-backward" />
				</router-link>
			</li>
			<li v-if="shouldRenderPrevLink">
				<router-link :to="getPreviousLink()" title="Halaman sebelumnya" :disabled="disabled">
					<i class="fa fa-chevron-left" />
				</router-link>
			</li>
			<li v-for="(page, index) in pagesNumber" 
				:key="index" 
				:class="{
					'active': page == getData('current_page', 1)
				}">
				<router-link :to="getLink(page)" :disabled="disabled">
					{{ page }}
				</router-link>
			</li>
			<li v-if="shouldRenderNextLink">
				<router-link :to="getNextLink()" title="Halaman berikutnya" :disabled="disabled">
					<i class="fa fa-chevron-right" />
				</router-link>
			</li>
			<li v-if="shouldRenderLastLink">
				<router-link :to="getLastLink()" title="Halaman terakhir" :disabled="disabled">
					<i class="fa fa-step-forward" />
				</router-link>
			</li>
		</ul>
	</div>
</template>

<script>
import _ from 'lodash'

export default {
	computed: {
		pagesNumber() {
			if (!this.getData('to')) {
				return [];
			}

			let from = this.getData('current_page') - this.offset;

			if (from < 1) {
				from = 1;
			}

			let to = from + (this.offset * 2);

			if (to >= this.getData('last_page', 1)) {
				to = this.getData('last_page', 1);
			}

			let pagesArray = [];

			for (let page = from; page <= to; page++) {
				pagesArray.push(page);
			}

			return pagesArray;
		},
		shouldRenderFirstLink() {
			return this.shouldRenderPrevLink
		},
		shouldRenderLastLink() {
			return this.shouldRenderNextLink && _.get(this.pagination, 'last_page', 1) > 1
		},
		shouldRenderNextLink() {
			const pagination = this.pagination
			return _.get(pagination, 'current_page', 1) < _.get(pagination, 'last_page', 1)
		},
		shouldRenderPrevLink() {
			return _.get(this.pagination, 'current_page', 1) > 1
		},
	},
	methods: {
		getData(key, defaultValue = null) {
			return _.get(this.pagination, key, defaultValue);
		},
		getFirstLink() {
			return {
				query: { 
					...this.query,
					page: 1,
				},
			} 
		},
		getLastLink() {
			return {
				query: { 
					...this.query,
					page: _.get(this.pagination, 'last_page', 1),
				},
			} 
		},
		getPreviousLink() {
			return {
				query: { 
					...this.query,
					page: _.get(this.pagination, 'current_page', 1) - 1,
				}
			}
		},
		getLink(page) {
			return {
				query: { 
					...this.query,
					page,
				}
			}
		},
		getNextLink() {
			return {
				query: { 
					...this.query,
					page: _.get(this.pagination, 'current_page', 1) + 1,
				}
			}
		},
	},
	props: {
		disabled: {
			type: Boolean,
			required: false,
			default: false,
		},
		pagination: {
			type: Object,
			required: false,
			default: null,
		},
		offset: {
			type: Number,
			default: 2,
		},
		query: {
			type: Object,
			required: false,
			default: () => ({}),
		},
	},
}
</script>
